import { useTranslation } from '@mc/i18n'
import { GiftButton } from '@mc/promos'

import CTA from 'components/CTA'
import { TrackProps } from 'components/Subscription'

import { ValuePropositionTiles } from './components/ValuePropositionTiles'

interface WhatsInMembershipWithImagesVariantProps {
  trackProps: TrackProps
  location: string
}

export const WhatsInMembershipWithImagesVariant = ({
  trackProps,
  location,
}: WhatsInMembershipWithImagesVariantProps) => {
  const { t } = useTranslation('@mc/next')

  return (
    <div className='d-flex flex-column mc-gap-9'>
      <div className='d-flex flex-column flex-lg-row justify-content-between align-items-lg-start mc-gap-9'>
        <h2 className='mc-text-h2 mc-text-lg--left mc-text--center'>
          {t('subscription.title')}
        </h2>
        <div className='d-flex justify-content-center mc-gap-3'>
          <CTA trackProps={trackProps} />
          <GiftButton location={location} />
        </div>
      </div>
      <ValuePropositionTiles />
    </div>
  )
}
